var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 319,
    viewBox: "0 0 330 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2791_1173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.411 270.41H-30.4463V270.607H362.411V270.41Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.046 283.071H297.023V283.268H323.046V283.071Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.799 285.211H222.971V285.408H229.799V285.211Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.238 275.769H281.16V275.965H296.238V275.769Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7075 277.091H10.7725V277.288H44.7075V277.091Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6816 277.091H51.708V277.288H56.6816V277.091Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.457 280.411H72.8516V280.608H146.457V280.411Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.768 235.315H4.05474C2.86623 235.313 1.72711 234.839 0.887438 233.997C0.0477681 233.154 -0.42383 232.012 -0.423828 230.822V17.2399C-0.413482 16.0564 0.0626812 14.9249 0.901235 14.0909C1.73979 13.257 2.87301 12.7882 4.05474 12.7861H155.768C156.958 12.7861 158.099 13.2595 158.941 14.1021C159.782 14.9447 160.255 16.0876 160.255 17.2792V230.822C160.255 232.014 159.782 233.157 158.941 233.999C158.099 234.842 156.958 235.315 155.768 235.315ZM4.05474 12.9435C2.91833 12.9456 1.82917 13.3992 1.02633 14.2047C0.223502 15.0102 -0.227401 16.1018 -0.2274 17.2399V230.822C-0.227401 231.96 0.223502 233.052 1.02633 233.857C1.82917 234.663 2.91833 235.116 4.05474 235.119H155.768C156.905 235.116 157.995 234.663 158.8 233.858C159.604 233.053 160.056 231.961 160.058 230.822V17.2399C160.056 16.101 159.604 15.0095 158.8 14.2042C157.995 13.3989 156.905 12.9456 155.768 12.9435H4.05474Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.725 235.315H174.004C172.815 235.313 171.675 234.839 170.834 233.997C169.993 233.155 169.52 232.013 169.518 230.822V17.2399C169.53 16.0557 170.008 14.9241 170.848 14.0905C171.687 13.2568 172.822 12.7881 174.004 12.7861H325.725C326.906 12.7902 328.037 13.26 328.874 14.0937C329.711 14.9274 330.186 16.0578 330.196 17.2399V230.822C330.196 232.011 329.726 233.152 328.888 233.994C328.05 234.836 326.913 235.311 325.725 235.315ZM174.004 12.9435C172.867 12.9456 171.777 13.3989 170.973 14.2042C170.169 15.0095 169.716 16.101 169.714 17.2399V230.822C169.716 231.961 170.169 233.053 170.973 233.858C171.777 234.663 172.867 235.116 174.004 235.119H325.725C326.863 235.116 327.953 234.663 328.757 233.858C329.561 233.053 330.013 231.961 330.015 230.822V17.2399C330.013 16.101 329.561 15.0095 328.757 14.2042C327.953 13.3989 326.863 12.9456 325.725 12.9435H174.004Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.526 61.7148H129.163V245.482H319.526V61.7148Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.527 65.0498H132.221V242.271H319.527V65.0498Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.604 199.354V146.043H139.127V139.001L151.573 133.178V125.97H153.647V146.043H155.721V199.354H158.487V171.656H164.71V157.123H166.784V199.354H171.616V183.428H175.074V179.273H182.679V164.74H186.828V155.045H191.668V140.504H193.742V155.045H198.582V164.74H202.723V179.273H210.329V183.428H213.786V199.354H217.934V179.273H225.54V134.972H227.614V130.125H244.201V134.972H247.658V166.817H261.486V170.271H266.319V172.349H261.486V184.813H275.999V143.273H278.764V134.972H285.679V103.127H287.753V134.972H292.593V143.273H319.527V242.271H132.221V199.354H133.604Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 145.446H303.175V147.406H305.131V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 148.735H303.175V150.695H305.131V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 161.891H303.175V163.85H305.131V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 165.173H303.175V167.132H305.131V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 168.463H303.175V170.422H305.131V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 178.329H303.175V180.288H305.131V178.329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.131 181.619H303.175V183.578H305.131V181.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.02 158.604H300.063V160.563H302.02V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.02 161.891H300.063V163.85H302.02V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 165.173H300.064V167.132H302.021V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 168.463H300.064V170.422H302.021V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 171.752H300.064V173.711H302.021V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 178.329H300.064V180.288H302.021V178.329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 181.619H300.064V183.578H302.021V181.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 145.446H296.952V147.406H298.909V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 148.735H296.952V150.695H298.909V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 152.024H296.952V153.984H298.909V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 155.314H296.952V157.274H298.909V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 158.604H296.952V160.563H298.909V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 161.891H296.952V163.85H298.909V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 165.173H296.952V167.132H298.909V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 168.463H296.952V170.422H298.909V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 171.752H296.952V173.711H298.909V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 175.04H296.952V176.999H298.909V175.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.909 181.619H296.952V183.578H298.909V181.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 145.446H293.842V147.406H295.798V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 148.735H293.842V150.695H295.798V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 152.024H293.842V153.984H295.798V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 155.314H293.842V157.274H295.798V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 158.604H293.842V160.563H295.798V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.798 161.891H293.842V163.85H295.798V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.797 165.173H293.841V167.132H295.797V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.797 194.775H293.841V196.735H295.797V194.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 145.446H290.73V147.406H292.687V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 148.735H290.73V150.695H292.687V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 152.024H290.73V153.984H292.687V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 155.314H290.73V157.274H292.687V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 158.604H290.73V160.563H292.687V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 161.891H290.73V163.85H292.687V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 165.173H290.73V167.132H292.687V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 168.463H290.73V170.422H292.687V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 188.197H290.73V190.157H292.687V188.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 191.486H290.73V193.446H292.687V191.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 194.776H290.73V196.736H292.687V194.776Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 198.057H290.73V200.016H292.687V198.057Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.687 211.213H290.73V213.172H292.687V211.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 145.446H287.618V147.406H289.575V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 148.735H287.618V150.695H289.575V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 152.024H287.618V153.984H289.575V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 155.314H287.618V157.274H289.575V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 158.604H287.618V160.563H289.575V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 161.891H287.618V163.85H289.575V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 165.173H287.618V167.132H289.575V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 168.463H287.618V170.422H289.575V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 171.752H287.618V173.711H289.575V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 175.04H287.618V176.999H289.575V175.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 184.908H287.618V186.868H289.575V184.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 188.197H287.618V190.157H289.575V188.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 191.486H287.618V193.446H289.575V191.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 194.776H287.618V196.736H289.575V194.776Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 198.057H287.618V200.016H289.575V198.057Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.575 211.213H287.618V213.172H289.575V211.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 145.446H284.507V147.406H286.463V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 148.735H284.507V150.695H286.463V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 152.024H284.507V153.984H286.463V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 155.314H284.507V157.274H286.463V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 158.604H284.507V160.563H286.463V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 161.891H284.507V163.85H286.463V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 165.173H284.507V167.132H286.463V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 168.463H284.507V170.422H286.463V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 171.752H284.507V173.711H286.463V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 175.04H284.507V176.999H286.463V175.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 178.329H284.507V180.288H286.463V178.329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 181.619H284.507V183.578H286.463V181.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 184.908H284.507V186.868H286.463V184.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 188.197H284.507V190.157H286.463V188.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 191.486H284.507V193.446H286.463V191.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 194.776H284.507V196.736H286.463V194.776Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 198.057H284.507V200.016H286.463V198.057Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.463 201.346H284.507V203.305H286.463V201.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 145.446H281.396V147.406H283.352V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 148.735H281.396V150.695H283.352V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 152.024H281.396V153.984H283.352V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 155.314H281.396V157.274H283.352V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 158.604H281.396V160.563H283.352V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 161.891H281.396V163.85H283.352V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 165.173H281.396V167.132H283.352V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 168.463H281.396V170.422H283.352V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 171.752H281.396V173.711H283.352V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 175.04H281.396V176.999H283.352V175.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 184.908H281.396V186.868H283.352V184.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 188.197H281.396V190.157H283.352V188.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 191.486H281.396V193.446H283.352V191.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.352 194.775H281.396V196.735H283.352V194.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 145.446H278.292V147.406H280.248V145.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 148.735H278.292V150.695H280.248V148.735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 152.024H278.292V153.984H280.248V152.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 155.314H278.292V157.274H280.248V155.314Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 158.604H278.292V160.563H280.248V158.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 161.891H278.292V163.85H280.248V161.891Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 165.173H278.292V167.132H280.248V165.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 168.463H278.292V170.422H280.248V168.463Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 171.752H278.292V173.711H280.248V171.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 175.04H278.292V176.999H280.248V175.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 184.908H278.292V186.868H280.248V184.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 188.197H278.292V190.157H280.248V188.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.248 191.486H278.292V193.446H280.248V191.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 136.909H243.265V138.868H245.221V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 140.198H243.265V142.158H245.221V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 143.487H243.265V145.447H245.221V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 146.775H243.265V148.735H245.221V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 150.064H243.265V152.024H245.221V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 153.354H243.265V155.313H245.221V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 156.636H243.265V158.595H245.221V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 159.924H243.265V161.883H245.221V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 169.792H243.265V171.751H245.221V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.221 173.081H243.265V175.04H245.221V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 136.909H240.153V138.868H242.11V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 140.198H240.153V142.158H242.11V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 143.487H240.153V145.447H242.11V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 146.775H240.153V148.735H242.11V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 150.064H240.153V152.024H242.11V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 153.354H240.153V155.313H242.11V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 156.636H240.153V158.595H242.11V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 159.924H240.153V161.883H242.11V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 173.081H240.153V175.04H242.11V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 136.909H237.042V138.868H238.998V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 140.198H237.042V142.158H238.998V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 143.487H237.042V145.447H238.998V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 146.775H237.042V148.735H238.998V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 150.064H237.042V152.024H238.998V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 153.354H237.042V155.313H238.998V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 156.636H237.042V158.595H238.998V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.998 159.924H237.042V161.883H238.998V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 136.909H233.931V138.868H235.887V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 140.198H233.931V142.158H235.887V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 143.487H233.931V145.447H235.887V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 146.775H233.931V148.735H235.887V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 150.064H233.931V152.024H235.887V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 153.354H233.931V155.313H235.887V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 159.924H233.931V161.883H235.887V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 163.213H233.931V165.172H235.887V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 173.081H233.931V175.04H235.887V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 176.371H233.931V178.33H235.887V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 179.66H233.931V181.619H235.887V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 182.949H233.931V184.909H235.887V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 186.237H233.931V188.197H235.887V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 189.519H233.931V191.478H235.887V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.887 192.809H233.931V194.768H235.887V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 136.909H230.819V138.868H232.776V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 140.198H230.819V142.158H232.776V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 143.487H230.819V145.447H232.776V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 146.775H230.819V148.735H232.776V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 150.064H230.819V152.024H232.776V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 153.354H230.819V155.313H232.776V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 163.213H230.819V165.172H232.776V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 166.503H230.819V168.462H232.776V166.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 169.792H230.819V171.751H232.776V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 173.081H230.819V175.04H232.776V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 176.371H230.819V178.33H232.776V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 179.66H230.819V181.619H232.776V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 182.949H230.819V184.909H232.776V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 186.237H230.819V188.197H232.776V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 189.519H230.819V191.478H232.776V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 192.809H230.819V194.768H232.776V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 196.098H230.819V198.057H232.776V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.776 202.675H230.819V204.634H232.776V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 136.909H227.708V138.868H229.664V136.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 140.198H227.708V142.158H229.664V140.198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 143.487H227.708V145.447H229.664V143.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 146.775H227.708V148.735H229.664V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 150.064H227.708V152.024H229.664V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 153.354H227.708V155.313H229.664V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 163.213H227.708V165.172H229.664V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 166.503H227.708V168.462H229.664V166.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 169.792H227.708V171.751H229.664V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 173.081H227.708V175.04H229.664V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 182.949H227.708V184.909H229.664V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 186.237H227.708V188.197H229.664V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 189.519H227.708V191.478H229.664V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 192.809H227.708V194.768H229.664V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 196.098H227.708V198.057H229.664V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 202.675H227.708V204.634H229.664V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.664 205.965H227.708V207.924H229.664V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 167.486H199.485V169.446H201.442V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 170.775H199.485V172.735H201.442V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 174.064H199.485V176.024H201.442V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 177.346H199.485V179.305H201.442V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 180.636H199.485V182.595H201.442V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 183.925H199.485V185.884H201.442V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 187.214H199.485V189.173H201.442V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 197.081H199.485V199.04H201.442V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 200.369H199.485V202.328H201.442V200.369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.442 203.658H199.485V205.618H201.442V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 167.486H196.374V169.446H198.33V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 170.775H196.374V172.735H198.33V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 174.064H196.374V176.024H198.33V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 177.346H196.374V179.305H198.33V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 180.636H196.374V182.595H198.33V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 183.925H196.374V185.884H198.33V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33 187.214H196.374V189.173H198.33V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 167.486H193.263V169.446H195.219V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 170.775H193.263V172.735H195.219V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 174.064H193.263V176.024H195.219V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 177.346H193.263V179.305H195.219V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 180.636H193.263V182.595H195.219V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 183.925H193.263V185.884H195.219V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 187.214H193.263V189.173H195.219V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 167.486H190.151V169.446H192.108V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 170.775H190.151V172.735H192.108V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 174.064H190.151V176.024H192.108V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 177.346H190.151V179.305H192.108V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 180.636H190.151V182.595H192.108V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 183.925H190.151V185.884H192.108V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 187.214H190.151V189.173H192.108V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 190.503H190.151V192.462H192.108V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 193.793H190.151V195.752H192.108V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 197.081H190.151V199.04H192.108V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.108 200.369H190.151V202.328H192.108V200.369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 167.486H187.04V169.446H188.996V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 170.775H187.04V172.735H188.996V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 174.064H187.04V176.024H188.996V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 177.346H187.04V179.305H188.996V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 180.636H187.04V182.595H188.996V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 183.925H187.04V185.884H188.996V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 187.214H187.04V189.173H188.996V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 190.503H187.04V192.462H188.996V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 193.793H187.04V195.752H188.996V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 197.081H187.04V199.04H188.996V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 200.369H187.04V202.328H188.996V200.369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 203.658H187.04V205.618H188.996V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 213.519H187.04V215.478H188.996V213.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 216.808H187.04V218.767H188.996V216.808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 167.486H183.929V169.446H185.885V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 170.775H183.929V172.735H185.885V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 174.064H183.929V176.024H185.885V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 183.925H183.929V185.884H185.885V183.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 187.214H183.929V189.173H185.885V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 190.503H183.929V192.462H185.885V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 193.793H183.929V195.752H185.885V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 197.081H183.929V199.04H185.885V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 200.369H183.929V202.328H185.885V200.369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 203.658H183.929V205.618H185.885V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 213.519H183.929V215.478H185.885V213.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 216.808H183.929V218.767H185.885V216.808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 220.097H183.929V222.056H185.885V220.097Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 147.752H151.329V149.711H153.286V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 151.04H151.329V152.999H153.286V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 154.33H151.329V156.289H153.286V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 157.619H151.329V159.578H153.286V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 160.907H151.329V162.867H153.286V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 164.196H151.329V166.156H153.286V164.196Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 167.486H151.329V169.446H153.286V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 170.775H151.329V172.735H153.286V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 174.064H151.329V176.024H153.286V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 177.346H151.329V179.305H153.286V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 180.636H151.329V182.595H153.286V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 183.924H151.329V185.883H153.286V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 187.214H151.329V189.173H153.286V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 190.503H151.329V192.462H153.286V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 193.793H151.329V195.752H153.286V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 197.081H151.329V199.04H153.286V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 200.37H151.329V202.329H153.286V200.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 203.658H151.329V205.618H153.286V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 206.948H151.329V208.908H153.286V206.948Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 210.23H151.329V212.19H153.286V210.23Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 213.519H151.329V215.478H153.286V213.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 216.808H151.329V218.767H153.286V216.808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.286 220.097H151.329V222.056H153.286V220.097Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 147.752H148.217V149.711H150.173V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 151.04H148.218V152.999H150.174V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 154.33H148.218V156.289H150.174V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 157.619H148.217V159.578H150.173V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 160.907H148.217V162.867H150.173V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 164.196H148.218V166.156H150.174V164.196Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 167.486H148.218V169.446H150.174V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 170.775H148.217V172.735H150.173V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 174.064H148.217V176.024H150.173V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 177.346H148.218V179.305H150.174V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 180.636H148.218V182.595H150.174V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 183.924H148.217V185.883H150.173V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 187.214H148.217V189.173H150.173V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 190.503H148.218V192.462H150.174V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 193.793H148.218V195.752H150.174V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 197.081H148.217V199.04H150.173V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.173 200.37H148.217V202.329H150.173V200.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 203.658H148.218V205.618H150.174V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.174 206.948H148.218V208.908H150.174V206.948Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 147.752H145.105V149.711H147.062V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 151.04H145.105V152.999H147.062V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 154.33H145.105V156.289H147.062V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 157.619H145.105V159.578H147.062V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 160.907H145.105V162.867H147.062V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 164.196H145.105V166.156H147.062V164.196Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 167.486H145.105V169.446H147.062V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 170.775H145.105V172.735H147.062V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 174.064H145.105V176.024H147.062V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 177.346H145.105V179.305H147.062V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 180.636H145.105V182.595H147.062V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 183.924H145.105V185.883H147.062V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 187.214H145.105V189.173H147.062V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 190.503H145.105V192.462H147.062V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 193.793H145.105V195.752H147.062V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 197.081H145.105V199.04H147.062V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 200.37H145.105V202.329H147.062V200.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 203.658H145.105V205.618H147.062V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.062 206.948H145.105V208.908H147.062V206.948Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 147.752H141.994V149.711H143.951V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 151.04H141.994V152.999H143.951V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 154.33H141.994V156.289H143.951V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 157.619H141.994V159.578H143.951V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 160.907H141.994V162.867H143.951V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 164.196H141.994V166.156H143.951V164.196Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 167.486H141.994V169.446H143.951V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 170.775H141.994V172.735H143.951V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 174.064H141.994V176.024H143.951V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 177.346H141.994V179.305H143.951V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 180.636H141.994V182.595H143.951V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 183.924H141.994V185.883H143.951V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 187.214H141.994V189.173H143.951V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 190.503H141.994V192.462H143.951V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 193.793H141.994V195.752H143.951V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 147.752H138.883V149.711H140.839V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 151.04H138.883V152.999H140.839V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 154.33H138.883V156.289H140.839V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 157.619H138.883V159.578H140.839V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 160.907H138.883V162.867H140.839V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 164.197H138.883V166.157H140.839V164.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 167.486H138.883V169.446H140.839V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 170.775H138.883V172.735H140.839V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 174.064H138.883V176.024H140.839V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 177.346H138.883V179.305H140.839V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 180.636H138.883V182.595H140.839V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 183.924H138.883V185.883H140.839V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 187.214H138.883V189.173H140.839V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 147.752H135.771V149.711H137.728V147.752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 151.04H135.771V152.999H137.728V151.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 154.33H135.771V156.289H137.728V154.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 157.619H135.771V159.578H137.728V157.619Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 160.907H135.771V162.867H137.728V160.907Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 164.197H135.771V166.157H137.728V164.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 167.486H135.771V169.446H137.728V167.486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 170.775H135.771V172.735H137.728V170.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 174.064H135.771V176.024H137.728V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 177.346H135.771V179.305H137.728V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 180.636H135.771V182.595H137.728V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.728 183.924H135.771V185.883H137.728V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 146.775H317.343V148.735H319.299V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 150.064H317.343V152.024H319.299V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 153.354H317.343V155.313H319.299V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 156.636H317.343V158.595H319.299V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 159.924H317.343V161.883H319.299V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 163.213H317.343V165.172H319.299V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 166.503H317.343V168.462H319.299V166.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 169.792H317.343V171.751H319.299V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 173.081H317.343V175.04H319.299V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 176.371H317.343V178.33H319.299V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 179.66H317.343V181.619H319.299V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 182.949H317.343V184.909H319.299V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 186.237H317.343V188.197H319.299V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 189.519H317.343V191.478H319.299V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 192.809H317.343V194.768H319.299V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 196.098H317.343V198.057H319.299V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 199.387H317.343V201.346H319.299V199.387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 205.965H317.343V207.924H319.299V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 209.254H317.343V211.213H319.299V209.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 212.543H317.343V214.502H319.299V212.543Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 215.832H317.343V217.791H319.299V215.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.299 219.113H317.343V221.073H319.299V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 146.775H314.231V148.735H316.188V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 150.064H314.231V152.024H316.188V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 153.354H314.231V155.313H316.188V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 156.636H314.231V158.595H316.188V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 159.924H314.231V161.883H316.188V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 163.213H314.231V165.172H316.188V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 166.503H314.231V168.462H316.188V166.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 169.792H314.231V171.751H316.188V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 173.081H314.231V175.04H316.188V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 176.371H314.231V178.33H316.188V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 179.66H314.231V181.619H316.188V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 182.949H314.231V184.909H316.188V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 186.237H314.231V188.197H316.188V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 189.519H314.231V191.478H316.188V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 192.809H314.231V194.768H316.188V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 196.098H314.231V198.057H316.188V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 215.832H314.231V217.791H316.188V215.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.188 219.113H314.231V221.073H316.188V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 146.775H311.128V148.735H313.084V146.775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 150.064H311.128V152.024H313.084V150.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 153.354H311.128V155.313H313.084V153.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 156.636H311.128V158.595H313.084V156.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 159.924H311.128V161.883H313.084V159.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 163.213H311.128V165.172H313.084V163.213Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 166.503H311.128V168.462H313.084V166.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 169.792H311.128V171.751H313.084V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 173.081H311.128V175.04H313.084V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 176.371H311.128V178.33H313.084V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 179.66H311.128V181.619H313.084V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 182.949H311.128V184.909H313.084V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 186.237H311.128V188.197H313.084V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 189.519H311.128V191.478H313.084V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 192.809H311.128V194.768H313.084V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 196.098H311.128V198.057H313.084V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 202.675H311.128V204.634H313.084V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 205.965H311.128V207.924H313.084V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 209.254H311.128V211.213H313.084V209.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 212.543H311.128V214.502H313.084V212.543Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.084 219.113H311.128V221.073H313.084V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 169.792H256.858V171.751H258.815V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 173.081H256.858V175.04H258.815V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 176.371H256.858V178.33H258.815V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 179.66H256.858V181.619H258.815V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 182.949H256.858V184.909H258.815V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 186.237H256.858V188.197H258.815V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 189.519H256.858V191.478H258.815V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 192.809H256.858V194.768H258.815V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 196.098H256.858V198.057H258.815V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 199.386H256.858V201.345H258.815V199.386Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 202.675H256.858V204.634H258.815V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 205.965H256.858V207.924H258.815V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 209.254H256.858V211.213H258.815V209.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 215.832H256.858V217.791H258.815V215.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 219.113H256.858V221.073H258.815V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 222.403H256.858V224.363H258.815V222.403Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 225.692H256.858V227.652H258.815V225.692Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 232.27H256.858V234.229H258.815V232.27Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 235.56H256.858V237.519H258.815V235.56Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.815 238.848H256.858V240.807H258.815V238.848Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 169.792H253.747V171.751H255.703V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 173.081H253.747V175.04H255.703V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 176.371H253.747V178.33H255.703V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 179.66H253.747V181.619H255.703V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 182.949H253.747V184.909H255.703V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 186.237H253.747V188.197H255.703V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 189.519H253.747V191.478H255.703V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 192.809H253.747V194.768H255.703V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 196.098H253.747V198.057H255.703V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 199.387H253.747V201.346H255.703V199.387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 202.675H253.747V204.634H255.703V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 205.965H253.747V207.924H255.703V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 209.254H253.747V211.213H255.703V209.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 219.113H253.747V221.073H255.703V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 222.403H253.747V224.363H255.703V222.403Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 228.98H253.747V230.94H255.703V228.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 232.27H253.747V234.229H255.703V232.27Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 235.56H253.747V237.519H255.703V235.56Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.703 238.848H253.747V240.807H255.703V238.848Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 169.792H250.636V171.751H252.592V169.792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 173.081H250.636V175.04H252.592V173.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 176.371H250.636V178.33H252.592V176.371Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 179.66H250.636V181.619H252.592V179.66Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 182.949H250.636V184.909H252.592V182.949Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 186.237H250.636V188.197H252.592V186.237Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 189.519H250.636V191.478H252.592V189.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 192.809H250.636V194.768H252.592V192.809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 196.098H250.636V198.057H252.592V196.098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 199.387H250.636V201.346H252.592V199.387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 202.675H250.636V204.634H252.592V202.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 205.965H250.636V207.924H252.592V205.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 209.254H250.636V211.213H252.592V209.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 212.543H250.636V214.502H252.592V212.543Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 219.113H250.636V221.073H252.592V219.113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 225.692H250.636V227.652H252.592V225.692Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 228.98H250.636V230.94H252.592V228.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 232.27H250.636V234.229H252.592V232.27Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 235.56H250.636V237.519H252.592V235.56Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.592 238.848H250.636V240.807H252.592V238.848Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 188.542H269.531V190.501H271.488V188.542Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 191.832H269.531V193.791H271.488V191.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 195.121H269.531V197.08H271.488V195.121Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 198.402H269.531V200.362H271.488V198.402Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 201.691H269.531V203.651H271.488V201.691Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 204.981H269.531V206.941H271.488V204.981Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 214.849H269.531V216.808H271.488V214.849Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 218.139H269.531V220.098H271.488V218.139Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 221.428H269.531V223.387H271.488V221.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 224.716H269.531V226.675H271.488V224.716Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 228.005H269.531V229.964H271.488V228.005Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 231.286H269.531V233.245H271.488V231.286Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.488 234.576H269.531V236.536H271.488V234.576Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 188.542H266.42V190.501H268.376V188.542Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 191.832H266.42V193.791H268.376V191.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 195.121H266.42V197.08H268.376V195.121Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 198.402H266.42V200.362H268.376V198.402Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 201.691H266.42V203.651H268.376V201.691Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 204.981H266.42V206.941H268.376V204.981Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 214.849H266.42V216.808H268.376V214.849Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 218.139H266.42V220.098H268.376V218.139Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 221.428H266.42V223.387H268.376V221.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 224.716H266.42V226.675H268.376V224.716Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 228.005H266.42V229.964H268.376V228.005Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 231.286H266.42V233.245H268.376V231.286Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.376 237.864H266.42V239.824H268.376V237.864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 174.064H163.075V176.024H165.032V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 177.346H163.075V179.305H165.032V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 180.636H163.075V182.595H165.032V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 183.924H163.075V185.883H165.032V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 187.214H163.075V189.173H165.032V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 190.503H163.075V192.462H165.032V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 193.793H163.075V195.752H165.032V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 197.081H163.075V199.04H165.032V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 200.37H163.075V202.329H165.032V200.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 203.658H163.075V205.618H165.032V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 206.948H163.075V208.908H165.032V206.948Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 213.519H163.075V215.478H165.032V213.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 216.808H163.075V218.767H165.032V216.808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 220.097H163.075V222.056H165.032V220.097Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 223.387H163.075V225.346H165.032V223.387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 226.676H163.075V228.635H165.032V226.676Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 229.965H163.075V231.924H165.032V229.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 233.254H163.075V235.213H165.032V233.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.032 236.543H163.075V238.502H165.032V236.543Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 174.064H159.972V176.024H161.928V174.064Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 177.346H159.972V179.305H161.928V177.346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 180.636H159.972V182.595H161.928V180.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 183.924H159.972V185.883H161.928V183.924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 187.214H159.972V189.173H161.928V187.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 190.503H159.972V192.462H161.928V190.503Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 193.793H159.972V195.752H161.928V193.793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 197.081H159.972V199.04H161.928V197.081Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 200.37H159.972V202.329H161.928V200.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 203.658H159.972V205.618H161.928V203.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 206.948H159.972V208.908H161.928V206.948Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 210.229H159.972V212.189H161.928V210.229Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 213.519H159.972V215.478H161.928V213.519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 216.808H159.972V218.767H161.928V216.808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 220.097H159.972V222.056H161.928V220.097Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 223.387H159.972V225.346H161.928V223.387Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 226.676H159.972V228.635H161.928V226.676Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 229.965H159.972V231.924H161.928V229.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 233.254H159.972V235.213H161.928V233.254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 236.543H159.972V238.502H161.928V236.543Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 186.867H178.405V188.827H180.362V186.867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 190.156H178.405V192.116H180.362V190.156Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 193.445H178.405V195.405H180.362V193.445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 196.734H178.405V198.694H180.362V196.734Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 200.024H178.405V201.984H180.362V200.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 203.313H178.405V205.273H180.362V203.313Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 206.602H178.405V208.561H180.362V206.602Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 209.883H178.405V211.842H180.362V209.883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 213.172H178.405V215.131H180.362V213.172Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.362 216.462H178.405V218.421H180.362V216.462Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 186.867H175.293V188.827H177.249V186.867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 190.156H175.293V192.116H177.249V190.156Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 193.445H175.293V195.405H177.249V193.445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 196.734H175.293V198.694H177.249V196.734Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 200.024H175.293V201.984H177.249V200.024Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 203.313H175.293V205.273H177.249V203.313Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 206.602H175.293V208.561H177.249V206.602Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.25 209.883H175.294V211.842H177.25V209.883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.25 213.172H175.294V215.131H177.25V213.172Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.753 62.0762H192.469V245.482H195.753V62.0762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.597 62.0762H254.312V245.482H257.597V62.0762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.433 62.0762H316.148V245.482H319.433V62.0762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6985 227.604H105.954C106.873 227.604 107.755 227.97 108.404 228.621C109.054 229.272 109.419 230.154 109.419 231.075V270.285H82.2414V231.106C82.2372 230.648 82.3235 230.194 82.4953 229.77C82.6671 229.346 82.9209 228.96 83.2423 228.635C83.5636 228.309 83.9461 228.051 84.3676 227.874C84.7892 227.697 85.2415 227.606 85.6985 227.604Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.419 233.411H82.2412V236.472H109.419V233.411Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6962 265.146H104.469C104.963 265.146 105.437 265.342 105.786 265.692C106.135 266.041 106.331 266.516 106.331 267.01V270.315H95.8262V267.01C95.8262 266.765 95.8746 266.522 95.9687 266.295C96.0627 266.068 96.2006 265.862 96.3743 265.689C96.5481 265.516 96.7543 265.378 96.9811 265.285C97.208 265.192 97.451 265.144 97.6962 265.146Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.363 270.315H98.836C98.5151 270.315 98.2073 270.187 97.9804 269.96C97.7535 269.733 97.626 269.425 97.626 269.103C97.6281 268.783 97.7564 268.477 97.9831 268.252C98.2098 268.026 98.5164 267.899 98.836 267.899H106.363C106.683 267.899 106.989 268.026 107.216 268.252C107.443 268.477 107.571 268.783 107.573 269.103C107.573 269.425 107.446 269.733 107.219 269.96C106.992 270.187 106.684 270.315 106.363 270.315Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.043 53.4704C236.989 51.1195 243.149 41.1389 240.801 31.1782C238.454 21.2175 228.488 15.0486 218.542 17.3995C208.596 19.7504 202.436 29.731 204.784 39.6917C207.131 49.6524 217.097 55.8213 227.043 53.4704Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31 50.9716C233.89 49.5769 239.716 41.4809 238.323 32.8887C236.93 24.2965 228.846 18.4618 220.267 19.8565C211.687 21.2512 205.861 29.3472 207.254 37.9394C208.647 46.5316 216.731 52.3663 225.31 50.9716Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.536 24.6133V35.6296L230.82 31.4985",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.536 36.3918C223.395 36.3918 223.256 36.3537 223.135 36.2816C223.018 36.212 222.921 36.113 222.853 35.9943C222.786 35.8757 222.75 35.7415 222.75 35.6049V24.5886C222.75 24.3799 222.833 24.1798 222.98 24.0322C223.127 23.8847 223.327 23.8018 223.536 23.8018C223.744 23.8018 223.944 23.8847 224.091 24.0322C224.239 24.1798 224.321 24.3799 224.321 24.5886V34.2751L230.434 30.8128C230.616 30.7109 230.83 30.6851 231.03 30.7412C231.231 30.7972 231.401 30.9305 231.503 31.1119C231.605 31.2925 231.632 31.5065 231.578 31.7069C231.523 31.9074 231.392 32.0782 231.212 32.182L223.921 36.3131C223.8 36.3689 223.668 36.3958 223.536 36.3918Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.982 305.946C250.118 305.946 318.324 301.958 318.324 297.038C318.324 292.119 250.118 288.131 165.982 288.131C81.8456 288.131 13.6396 292.119 13.6396 297.038C13.6396 301.958 81.8456 305.946 165.982 305.946Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.05 272.236C292.168 271.449 294.918 252.43 289.41 245.867C288.862 245.176 288.168 244.615 287.377 244.224C286.586 243.834 285.719 243.624 284.838 243.609C273.712 243.349 272.195 252.265 272.18 252.383L273.492 252.587C273.539 252.265 274.859 244.719 284.806 244.939C285.499 244.949 286.181 245.113 286.802 245.421C287.424 245.729 287.968 246.172 288.397 246.717C293.52 252.831 290.754 271.842 290.754 272.039L292.05 272.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.718 271.371L294.046 271.323C294.046 271.15 293.606 253.815 302.131 250.235C310.491 246.733 314.255 253.941 314.404 254.248L315.591 253.65C315.551 253.564 311.136 244.994 301.621 249.015C292.255 252.942 292.695 270.615 292.718 271.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.678 272.732C292.678 272.456 292.765 245.042 298.1 237.023C303.223 229.32 311.457 232.947 311.842 233.089L312.384 231.877C312.29 231.838 302.751 227.62 296.992 236.268C291.437 244.617 291.358 271.567 291.358 272.716L292.678 272.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.242 244.27C283.242 244.27 288.098 246.064 286.652 250.29C285.206 254.515 269.861 261.487 269.861 261.487C269.861 261.487 263.426 255.586 269.335 245.986C275.244 236.386 283.109 241.241 283.242 244.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.335 235.576C298.335 235.576 294.894 235.206 295.192 233.105C295.491 231.004 308.596 225.59 316.336 234.341C316.336 234.341 311.378 242.87 304.212 242.996C297.046 243.122 298.335 235.576 298.335 235.576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.911 249.638C301.911 249.638 299.554 247.718 302.1 246.781C304.645 245.845 317.264 246.105 317.39 258.585C317.39 258.585 302.72 261.032 300.89 256.271C299.059 251.51 301.911 249.638 301.911 249.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.242 244.27C283.242 244.27 288.098 246.064 286.652 250.29C285.206 254.515 269.861 261.487 269.861 261.487C269.861 261.487 263.426 255.586 269.335 245.986C275.244 236.386 283.109 241.241 283.242 244.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M298.335 235.576C298.335 235.576 294.894 235.206 295.192 233.105C295.491 231.004 308.596 225.59 316.336 234.341C316.336 234.341 311.378 242.87 304.212 242.996C297.046 243.122 298.335 235.576 298.335 235.576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M301.911 249.638C301.911 249.638 299.554 247.718 302.1 246.781C304.645 245.845 317.264 246.105 317.39 258.585C317.39 258.585 302.72 261.032 300.89 256.271C299.059 251.51 301.911 249.638 301.911 249.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.634 297.692H303.404L305.855 272.732H278.183L280.634 297.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M280.634 297.692H303.404L305.855 272.732H278.183L280.634 297.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.965 275.479H307.073V269.97H276.965V275.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.965 275.479H307.073V269.97H276.965V275.479Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.863 279.798L232.227 277.571V245.702H223.254V277.555L200.555 279.798C199.466 279.905 198.456 280.414 197.722 281.225C196.987 282.037 196.58 283.093 196.579 284.188V287.596H258.871V284.188C258.871 283.087 258.46 282.026 257.718 281.214C256.977 280.401 255.958 279.896 254.863 279.798Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M254.863 279.798L232.227 277.571V245.702H223.254V277.555L200.555 279.798C199.466 279.905 198.456 280.414 197.722 281.225C196.987 282.037 196.58 283.093 196.579 284.188V287.596H258.871V284.188C258.871 283.087 258.46 282.026 257.718 281.214C256.977 280.401 255.958 279.896 254.863 279.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.944 297.699C202.185 297.699 204.813 295.068 204.813 291.821C204.813 288.575 202.185 285.943 198.944 285.943C195.702 285.943 193.074 288.575 193.074 291.821C193.074 295.068 195.702 297.699 198.944 297.699Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.449 297.699C259.691 297.699 262.319 295.068 262.319 291.821C262.319 288.575 259.691 285.943 256.449 285.943C253.208 285.943 250.58 288.575 250.58 291.821C250.58 295.068 253.208 297.699 256.449 297.699Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.714 224.174H233.775V249.299C233.775 250.161 233.433 250.987 232.824 251.597C232.216 252.206 231.39 252.549 230.53 252.549H224.959C224.098 252.549 223.273 252.206 222.664 251.597C222.056 250.987 221.714 250.161 221.714 249.299V224.174Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M221.714 224.174H233.775V249.299C233.775 250.161 233.433 250.987 232.824 251.597C232.216 252.206 231.39 252.549 230.53 252.549H224.959C224.098 252.549 223.273 252.206 222.664 251.597C222.056 250.987 221.714 250.161 221.714 249.299V224.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.189 174.372C249.189 174.372 250.902 216.864 239.085 224.174H252.576C252.576 224.174 263.026 209.703 260.071 174.372H249.189Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M249.189 174.372C249.189 174.372 250.902 216.864 239.085 224.174H252.576C252.576 224.174 263.026 209.703 260.071 174.372H249.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.165 227.432H196.728V222.167C196.728 221.124 197.142 220.123 197.879 219.385C198.615 218.648 199.615 218.233 200.656 218.233H253.236C254.278 218.233 255.278 218.648 256.014 219.385C256.751 220.123 257.165 221.124 257.165 222.167V227.432Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.784 227.432H258.099C258.972 227.432 259.679 226.724 259.679 225.85V224.418C259.679 223.544 258.972 222.836 258.099 222.836H195.784C194.912 222.836 194.205 223.544 194.205 224.418V225.85C194.205 226.724 194.912 227.432 195.784 227.432Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.784 227.432H258.099C258.972 227.432 259.679 226.724 259.679 225.85V224.418C259.679 223.544 258.972 222.836 258.099 222.836H195.784C194.912 222.836 194.205 223.544 194.205 224.418V225.85C194.205 226.724 194.912 227.432 195.784 227.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38 151.592H241.773C235.446 151.592 230.317 156.728 230.317 163.064V171.531C230.317 177.867 235.446 183.004 241.773 183.004H263.38C269.707 183.004 274.836 177.867 274.836 171.531V163.064C274.836 156.728 269.707 151.592 263.38 151.592Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.236 116.875L171.923 105.489C171.923 105.489 173.777 103.774 172.504 102.035C171.231 100.296 163.28 95.4094 161.834 96.2671C160.388 97.1248 157.159 100.367 158.903 102.169C160.648 103.971 168.332 106.969 168.332 106.969L172.15 121.919L176.236 116.875Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.352 138.522C206.352 138.522 186.71 134.485 184.612 133.517C182.514 132.549 174.625 109.392 174.625 109.392L168.567 112.224C168.567 112.224 173.439 135.469 178.42 140.993C183.402 146.517 204.663 151.222 204.663 151.222L206.352 138.522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.615 151.198L204.254 151.112C203.185 150.868 199.83 150.081 195.847 148.909C189.38 147.028 181.224 144.187 178.38 141C173.407 135.492 168.527 112.224 168.527 112.224L174.577 109.392C174.577 109.392 182.474 132.557 184.611 133.517C186.748 134.477 206.352 138.522 206.352 138.522L204.615 151.198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.681 108.936L175.93 111.351L168.151 114.035L168.45 111.084L174.681 108.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.765 150.876C203.681 150.719 200.279 150.191 196.209 149.302C198.527 145.289 205.315 143.228 205.315 143.228L204.765 150.876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.009 122.486C234.009 122.486 235.164 133.368 231.141 136.044C227.119 138.719 207.311 135.587 205.064 131.204C202.816 126.821 211.271 114.939 211.271 114.939L234.009 122.486Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.875 265.682L159.045 266.933L161.661 259.788L164.034 253.288L158.149 250.778L155.886 258.663L153.875 265.682Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.886 258.663L161.661 259.788L164.034 253.288L158.149 250.778L155.886 258.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.405 254.894L163.571 257.562C163.571 257.562 182.687 209.696 186.616 209.562C190.545 209.428 230.545 227.81 240.571 217.596C250.597 207.382 236.1 182.753 236.1 182.753C236.1 182.753 211.987 179.307 210.172 184.76C209.725 186.367 209.384 188.002 209.15 189.654C208.875 191.322 208.687 192.723 208.687 192.723C207.94 192.534 183.732 186.278 174.194 192.723C164.49 199.278 156.405 254.894 156.405 254.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M156.405 254.894L163.571 257.562C163.571 257.562 182.687 209.696 186.616 209.562C190.545 209.428 230.545 227.81 240.571 217.596C250.597 207.382 236.1 182.753 236.1 182.753C236.1 182.753 211.987 179.307 210.172 184.76C209.725 186.367 209.384 188.002 209.15 189.654C208.875 191.322 208.687 192.723 208.687 192.723C207.94 192.534 183.732 186.278 174.194 192.723C164.49 199.278 156.405 254.894 156.405 254.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.623 286.102L202.77 284.788L201.78 277.383L200.86 270.601L194.496 271.175L196.146 279.083L197.623 286.102Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.185 279.24L201.811 277.525L200.876 270.671L194.504 271.214L196.185 279.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.533 254.901L156.09 251.353L155.643 255.633L163.563 258.434L166.533 254.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.253 220.02C223.253 220.02 221.619 220.059 196.327 218.879C196.327 218.879 200.106 250.543 202.173 274.252L194.606 275.542C194.606 275.542 176.535 224.781 176.731 216.715C176.928 208.65 186.16 206.289 186.16 206.289C186.16 206.289 204.176 216.715 223.253 220.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M223.253 220.02C223.253 220.02 221.619 220.059 196.327 218.879C196.327 218.879 200.106 250.543 202.173 274.252L194.606 275.542C194.606 275.542 176.535 224.781 176.731 216.715C176.928 208.65 186.16 206.289 186.16 206.289C186.16 206.289 204.176 216.715 223.253 220.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M223.253 220.02C223.253 220.02 221.619 220.059 196.327 218.879C196.327 218.879 200.106 250.543 202.173 274.252L194.606 275.542C194.606 275.542 176.535 224.781 176.731 216.715C176.928 208.65 186.16 206.289 186.16 206.289C186.16 206.289 204.176 216.715 223.253 220.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.272 271.954L192.877 273.142L194.888 277.218L203.303 276.14L203.272 271.954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M208.687 192.722L222.79 195.665C222.79 195.665 214.996 191.353 209.15 189.653C208.875 191.322 208.687 192.722 208.687 192.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.518 178.999L236.099 182.752L210.171 184.759L209.487 180.313L235.518 178.999Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.518 178.999L236.099 182.752L210.171 184.759L209.487 180.313L235.518 178.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.34 185.287L228.622 185.155L227.951 178.619L226.669 178.751L227.34 185.287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.822 184.635L221.499 184.27L221.222 179.958L215.545 180.324L215.822 184.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.432 185.975L212.714 185.843L212.043 179.307L210.761 179.439L211.432 185.975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M227.34 185.287L228.622 185.155L227.951 178.619L226.669 178.751L227.34 185.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M211.432 185.975L212.714 185.843L212.043 179.307L210.761 179.439L211.432 185.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.881 138.168C210.738 139.512 215.778 140.067 220.81 139.813C229.138 139.388 239.054 143.409 239.054 143.409L235.487 178.975L209.448 180.29C209.448 180.29 200.735 150.616 205.881 138.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.068 118.079C210.068 118.079 211.53 100.815 225.94 107.063C244.011 114.932 229.648 135.973 220.809 131.661C211.97 127.349 210.068 118.079 210.068 118.079Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M214.107 140.78L214.524 150.538L217.753 145.95C217.753 145.95 216.598 156.738 217.274 162.616C217.274 162.616 217.895 152.08 219.356 145.95L222.79 150.538L227.716 140.843C227.716 140.843 219.741 137.971 214.107 140.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.571 142.622L226.028 140.514C221.431 137.366 223.749 130.284 223.749 130.284L216.363 132.881C216.703 133.909 216.966 134.961 217.149 136.028C217.935 140.639 215.845 141.009 215.845 141.009L218.571 142.622Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.363 132.841C216.703 133.869 216.966 134.921 217.149 135.988C220.685 134.564 223.741 130.229 223.741 130.229L216.363 132.841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.187 110.714C214.642 109.266 211.758 112.288 209.794 118.945C207.334 127.246 207.877 133.651 216.449 133.667C228.093 133.683 232.045 113.122 221.187 110.714Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1 119.521C213.363 120.383 212.524 121.152 211.602 121.81C211.733 122.125 211.95 122.398 212.228 122.596C212.505 122.795 212.833 122.912 213.173 122.936L214.1 119.521Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.225 119.866C218.091 120.401 218.272 120.912 218.633 120.999C218.995 121.086 219.38 120.724 219.513 120.212C219.647 119.701 219.466 119.173 219.105 119.079C218.743 118.985 218.358 119.331 218.225 119.866Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.246 119.119L218.201 118.379C218.201 118.379 218.539 119.504 219.246 119.119Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.608 118.118C211.475 118.653 211.656 119.164 212.017 119.251C212.378 119.337 212.803 118.976 212.897 118.464C212.991 117.953 212.85 117.425 212.488 117.331C212.127 117.237 211.742 117.583 211.608 118.118Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.631 117.371L211.555 116.655C211.555 116.655 211.924 117.749 212.631 117.371Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.909 117.261C221.857 117.262 221.805 117.248 221.759 117.222C221.713 117.196 221.676 117.157 221.65 117.111C221.391 116.707 221.045 116.365 220.637 116.112C220.229 115.859 219.77 115.7 219.293 115.648C219.218 115.638 219.15 115.6 219.101 115.542C219.053 115.483 219.029 115.409 219.034 115.333C219.042 115.257 219.079 115.187 219.138 115.139C219.197 115.09 219.272 115.067 219.348 115.073C219.927 115.129 220.485 115.319 220.979 115.628C221.472 115.936 221.888 116.355 222.192 116.852C222.21 116.885 222.22 116.922 222.224 116.96C222.227 116.997 222.222 117.035 222.211 117.071C222.199 117.107 222.18 117.14 222.155 117.169C222.131 117.197 222.1 117.221 222.067 117.237C222.017 117.257 221.963 117.265 221.909 117.261Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.594 114.293C214.541 114.293 214.489 114.276 214.445 114.246C214.059 114.061 213.636 113.964 213.208 113.964C212.779 113.964 212.356 114.061 211.97 114.246C211.936 114.26 211.9 114.267 211.863 114.267C211.826 114.266 211.79 114.259 211.756 114.244C211.723 114.229 211.692 114.208 211.667 114.181C211.641 114.155 211.622 114.123 211.609 114.089C211.595 114.054 211.588 114.017 211.588 113.98C211.588 113.942 211.596 113.906 211.61 113.871C211.625 113.837 211.646 113.806 211.673 113.78C211.7 113.753 211.731 113.733 211.766 113.719C212.235 113.5 212.748 113.392 213.266 113.403C213.784 113.414 214.292 113.544 214.752 113.782C214.783 113.802 214.811 113.828 214.832 113.859C214.854 113.889 214.869 113.924 214.877 113.961C214.885 113.997 214.886 114.035 214.879 114.072C214.872 114.109 214.858 114.144 214.838 114.175C214.81 114.213 214.773 114.244 214.731 114.265C214.688 114.285 214.642 114.295 214.594 114.293Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.893 123.335C225.893 123.335 224.023 117.276 225.406 113.224C225.406 113.224 213.62 105.048 210.068 118.079C210.068 118.079 211.381 106.103 222.687 108.337C233.993 110.572 230.293 127.026 223.402 130.645C223.402 130.645 227.04 127.12 225.893 123.335Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.518 124.523C224.748 123.779 225.263 123.156 225.951 122.792C226.639 122.427 227.443 122.351 228.187 122.58C230.167 123.249 230.207 127.631 224.95 127.513C224.188 127.458 223.937 126.664 224.518 124.523Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.985 125.42C212.16 126.224 212.276 127.039 212.331 127.86H212.755C214.712 128.025 215.67 127.45 216.142 126.774C216.367 126.437 216.507 126.051 216.55 125.648C216.584 125.421 216.584 125.191 216.55 124.964C215.289 125.399 213.949 125.557 212.622 125.428C212.245 125.452 211.985 125.42 211.985 125.42Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.654 125.467L212.772 126.183C214.611 126.333 215.915 126.183 216.551 125.688C216.585 125.461 216.585 125.23 216.551 125.003C215.3 125.433 213.972 125.592 212.654 125.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.756 127.9C214.712 128.065 215.671 127.491 216.142 126.814C215.4 126.766 214.656 126.848 213.942 127.058C213.468 127.207 213.053 127.501 212.756 127.9Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.209 111.242C221.209 111.242 221.461 122.596 228.281 123.965C235.101 125.335 227.652 109.361 227.652 109.361C227.652 109.361 217.516 102.735 210.759 107.41C204.002 112.084 210.084 118.08 210.084 118.08C210.084 118.08 211.49 109.644 221.209 111.242Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.812 121.636C223.766 121.635 223.721 121.619 223.686 121.589C218.846 117.78 221.235 110.494 221.258 110.423C221.276 110.374 221.312 110.333 221.359 110.31C221.406 110.286 221.46 110.282 221.51 110.297C221.559 110.315 221.599 110.351 221.621 110.398C221.643 110.446 221.645 110.5 221.628 110.549C221.628 110.62 219.31 117.631 223.93 121.282C223.949 121.299 223.964 121.321 223.974 121.344C223.984 121.368 223.989 121.394 223.989 121.419C223.989 121.445 223.984 121.471 223.974 121.494C223.964 121.518 223.949 121.539 223.93 121.557C223.917 121.578 223.9 121.596 223.879 121.609C223.859 121.623 223.836 121.632 223.812 121.636Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.254 126.295C229.39 128.608 227.166 129.907 225.289 129.206C223.411 128.506 222.594 126.059 223.458 123.745C224.322 121.432 226.546 120.134 228.424 120.842C230.301 121.55 231.119 123.989 230.254 126.295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.254 126.295C229.39 128.608 227.166 129.907 225.289 129.206C223.411 128.506 222.594 126.059 223.458 123.745C224.322 121.432 226.546 120.134 228.424 120.842C230.301 121.55 231.119 123.989 230.254 126.295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.054 122.51C228.054 122.51 230.875 109.865 224.55 106.552C225.27 106.646 225.984 106.785 226.687 106.969C227.473 107.205 232.556 112.335 230.003 123.698L228.054 122.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M228.054 122.51C228.054 122.51 230.875 109.865 224.55 106.552C225.27 106.646 225.984 106.785 226.687 106.969C227.473 107.205 232.556 112.335 230.003 123.698L228.054 122.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.268 129.749L215.797 129.678L215.923 128.891C219.393 129.426 222.938 128.673 225.893 126.774L226.357 127.404C223.385 129.376 219.803 130.209 216.268 129.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.268 129.749L215.797 129.678L215.923 128.891C219.393 129.426 222.938 128.673 225.893 126.774L226.357 127.404C223.385 129.376 219.803 130.209 216.268 129.749Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.987 125.98C229.422 127.507 227.945 128.341 226.711 127.9C225.477 127.459 224.927 125.823 225.501 124.296C226.075 122.77 227.544 121.936 228.777 122.376C230.011 122.817 230.561 124.454 229.987 125.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.53 130.032L214.893 129.946C214.782 129.931 214.675 129.895 214.578 129.839C214.481 129.783 214.396 129.708 214.328 129.618C214.26 129.529 214.21 129.427 214.182 129.319C214.154 129.21 214.147 129.097 214.162 128.986C214.176 128.874 214.212 128.766 214.267 128.668C214.323 128.57 214.398 128.484 214.487 128.415C214.576 128.346 214.678 128.296 214.787 128.267C214.896 128.238 215.009 128.231 215.121 128.246L215.75 128.333C215.974 128.364 216.177 128.482 216.315 128.662C216.453 128.841 216.515 129.068 216.488 129.293C216.457 129.517 216.339 129.72 216.16 129.859C215.98 129.997 215.754 130.059 215.53 130.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M215.53 130.032L214.893 129.946C214.782 129.931 214.675 129.895 214.578 129.839C214.481 129.783 214.396 129.708 214.328 129.618C214.26 129.529 214.21 129.427 214.182 129.319C214.154 129.21 214.147 129.097 214.162 128.986C214.176 128.874 214.212 128.766 214.267 128.668C214.323 128.57 214.398 128.484 214.487 128.415C214.576 128.346 214.678 128.296 214.787 128.267C214.896 128.238 215.009 128.231 215.121 128.246L215.75 128.333C215.974 128.364 216.177 128.482 216.315 128.662C216.453 128.841 216.515 129.068 216.488 129.293C216.457 129.517 216.339 129.72 216.16 129.859C215.98 129.997 215.754 130.059 215.53 130.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.023 137.782L219.355 142.37L221.225 148.004L227.715 140.843L224.023 137.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.274 138.743L218.028 142.276L215.616 147.273L214.107 140.781L217.274 138.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.025 141.764L225.736 131.826C225.736 131.826 224.424 129.355 224.707 128.835C224.99 128.316 226.404 121.643 227.41 120.919C228.415 120.196 232.556 121.431 232.973 122.108C233.389 122.784 229.005 131.826 229.005 131.826L227.433 142.598L223.025 141.764Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.054 143.408C246.518 151.057 231.566 168.384 222.994 167.644C214.422 166.904 223.214 135.492 223.214 135.492L228.714 136.397C228.714 136.397 226.789 149.994 227.394 151.057C227.999 152.119 236.579 140.867 239.054 143.408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.054 143.408C246.518 151.057 231.566 168.384 222.994 167.644C214.422 166.904 223.214 135.492 223.214 135.492L228.714 136.397C228.714 136.397 226.789 149.994 227.394 151.057C227.999 152.119 236.579 140.867 239.054 143.408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.789 134.509L221.979 137.105L229.625 137.782V135.516L222.789 134.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M211.201 155.055H208.105C207.762 155.055 207.484 155.333 207.484 155.676V161.531C207.484 161.874 207.762 162.152 208.105 162.152H211.201C211.544 162.152 211.822 161.874 211.822 161.531V155.676C211.822 155.333 211.544 155.055 211.201 155.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.264 155.526H207.744V160.35H211.264V155.526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.975 153.348H209.197V156.188H209.975V153.348Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.326 275.738C146.11 275.373 146.954 275.157 147.817 275.101C147.817 275.101 150.803 273.346 153.757 266.508H157.08C157.644 266.512 158.193 266.69 158.651 267.018C159.11 267.346 159.456 267.809 159.642 268.341C159.697 268.487 159.729 268.641 159.736 268.798C159.697 269.602 159.61 270.403 159.477 271.198C158.991 273.858 158.343 276.485 157.536 279.066L156.97 278.925L157.992 273.952C158.338 272.268 156.562 273.897 155.745 275.596C154.928 277.296 153.663 279.019 149.985 278.177C145.703 277.123 143.983 276.509 145.326 275.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.362 264.722C154.362 264.722 150.206 273.425 147.817 275.101C147.817 275.101 151.023 277.013 154.362 272.741C158.676 267.232 159.737 268.767 159.737 268.767C159.646 267.816 159.47 266.876 159.21 265.958C158.566 264.195 154.362 264.722 154.362 264.722Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.07 296.473C191.749 295.937 192.518 295.527 193.341 295.262C193.341 295.262 195.824 292.846 197.073 285.504L200.302 284.717C200.85 284.591 201.424 284.637 201.945 284.848C202.467 285.059 202.911 285.425 203.217 285.898C203.306 286.029 203.374 286.172 203.422 286.323C203.579 287.102 203.686 287.89 203.744 288.683C203.895 291.373 203.882 294.069 203.704 296.757H203.123L202.942 291.689C202.872 289.966 201.544 291.973 201.143 293.822C200.742 295.671 199.933 297.63 196.162 297.685C191.769 297.732 189.947 297.544 191.07 296.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.238 283.624C197.238 283.624 195.266 293.067 193.31 295.262C193.31 295.262 196.877 296.364 199.108 291.43C202 285.056 203.39 286.299 203.39 286.299C203.08 285.397 202.688 284.526 202.22 283.695C201.198 282.121 197.238 283.624 197.238 283.624Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.294 93.166H242.864C240.664 93.166 238.881 94.9522 238.881 97.1555V108.904C238.881 111.107 240.664 112.893 242.864 112.893H270.294C272.494 112.893 274.277 111.107 274.277 108.904V97.1555C274.277 94.9522 272.494 93.166 270.294 93.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.364 110.643L240.099 121.895L253.432 111.398L248.364 110.643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67 103.025C248.672 103.256 248.605 103.482 248.478 103.675C248.351 103.868 248.169 104.018 247.956 104.107C247.743 104.196 247.509 104.22 247.283 104.175C247.056 104.131 246.848 104.02 246.685 103.856C246.522 103.693 246.411 103.485 246.367 103.258C246.322 103.031 246.346 102.797 246.435 102.583C246.524 102.37 246.674 102.189 246.866 102.061C247.059 101.934 247.285 101.867 247.515 101.868C247.822 101.868 248.116 101.99 248.332 102.207C248.549 102.424 248.67 102.718 248.67 103.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.713 103.025C254.715 103.256 254.648 103.482 254.521 103.675C254.394 103.868 254.212 104.018 253.999 104.107C253.786 104.196 253.552 104.22 253.326 104.175C253.099 104.131 252.891 104.02 252.728 103.856C252.565 103.693 252.454 103.485 252.41 103.258C252.365 103.031 252.389 102.797 252.478 102.583C252.567 102.37 252.717 102.189 252.909 102.061C253.102 101.934 253.328 101.867 253.558 101.868C253.865 101.868 254.158 101.99 254.375 102.207C254.592 102.424 254.713 102.718 254.713 103.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.755 103.025C260.757 103.256 260.69 103.482 260.563 103.675C260.436 103.868 260.254 104.018 260.041 104.107C259.828 104.196 259.594 104.22 259.368 104.175C259.141 104.131 258.933 104.02 258.77 103.856C258.607 103.693 258.496 103.485 258.452 103.258C258.407 103.031 258.431 102.797 258.52 102.583C258.609 102.37 258.759 102.189 258.951 102.061C259.144 101.934 259.37 101.867 259.6 101.868C259.907 101.868 260.2 101.99 260.417 102.207C260.634 102.424 260.755 102.718 260.755 103.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.797 103.025C266.799 103.256 266.732 103.482 266.605 103.675C266.478 103.868 266.296 104.018 266.083 104.107C265.87 104.196 265.636 104.22 265.41 104.175C265.183 104.131 264.975 104.02 264.812 103.856C264.649 103.693 264.538 103.485 264.494 103.258C264.449 103.031 264.473 102.797 264.562 102.583C264.651 102.37 264.801 102.189 264.993 102.061C265.186 101.934 265.412 101.867 265.642 101.868C265.949 101.868 266.242 101.99 266.459 102.207C266.676 102.424 266.797 102.718 266.797 103.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.296 83.864L147.727 73.307C147.2 73.0226 146.542 73.22 146.258 73.748L140.013 85.3587C139.729 85.8867 139.926 86.5453 140.454 86.8297L160.023 97.3867C160.55 97.6711 161.208 97.4737 161.492 96.9457L167.737 85.335C168.021 84.807 167.824 84.1484 167.296 83.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M167.296 83.864L147.727 73.307C147.2 73.0226 146.542 73.22 146.258 73.748L140.013 85.3587C139.729 85.8867 139.926 86.5453 140.454 86.8297L160.023 97.3867C160.55 97.6711 161.208 97.4737 161.492 96.9457L167.737 85.335C168.021 84.807 167.824 84.1484 167.296 83.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.749 74.7061L151.838 86.1551C152.072 86.5913 152.43 86.9482 152.866 87.1807C153.303 87.4132 153.798 87.5109 154.29 87.4613L167.026 86.2023L154.062 88.1145C153.495 88.1984 152.917 88.0966 152.413 87.8243C151.909 87.5521 151.506 87.1239 151.265 86.6037L145.749 74.7061Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.892 72.5888C131.104 68.2138 134.341 59.3929 138.278 56.6939C142.214 53.9949 139.621 57.7326 139.621 57.7326C139.621 57.7326 143.354 54.0972 145.318 54.2073C147.282 54.3175 145.318 56.568 145.318 56.568C145.318 56.568 149.364 54.0736 151.226 54.2073C153.089 54.3411 151.226 56.4972 151.226 56.4972C151.226 56.4972 154.542 54.1365 155.886 55.246C157.229 56.3555 138.686 68.623 136.62 73.6118C134.554 78.6006 130.68 77.0032 130.892 72.5888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.892 72.5888C131.104 68.2138 134.341 59.3929 138.278 56.6939C142.214 53.9949 139.621 57.7326 139.621 57.7326C139.621 57.7326 143.354 54.0972 145.318 54.2073C147.282 54.3175 145.318 56.568 145.318 56.568C145.318 56.568 149.364 54.0736 151.226 54.2073C153.089 54.3411 151.226 56.4972 151.226 56.4972C151.226 56.4972 154.542 54.1365 155.886 55.246C157.229 56.3555 138.686 68.623 136.62 73.6118C134.554 78.6006 130.68 77.0032 130.892 72.5888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.826 71.9277L149.301 73.5015C149.34 73.5257 149.37 73.5625 149.386 73.6058C149.401 73.6491 149.402 73.6964 149.388 73.7401C149.373 73.7838 149.344 73.8213 149.306 73.8465C149.267 73.8718 149.221 73.8833 149.176 73.8792L146.575 73.6746L146.795 75.6733C146.801 75.7204 146.792 75.7683 146.769 75.8099C146.746 75.8515 146.71 75.8845 146.667 75.904C146.624 75.9234 146.575 75.9284 146.529 75.918C146.483 75.9076 146.441 75.8825 146.41 75.8464L144.909 74.1625L146.826 71.9277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M146.826 71.9277L149.301 73.5015C149.34 73.5257 149.37 73.5625 149.386 73.6058C149.401 73.6491 149.402 73.6964 149.388 73.7401C149.373 73.7838 149.344 73.8213 149.306 73.8465C149.267 73.8718 149.221 73.8833 149.176 73.8792L146.575 73.6746L146.795 75.6733C146.801 75.7204 146.792 75.7683 146.769 75.8099C146.746 75.8515 146.71 75.8845 146.667 75.904C146.624 75.9234 146.575 75.9284 146.529 75.918C146.483 75.9076 146.441 75.8825 146.41 75.8464L144.909 74.1625L146.826 71.9277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.058 62.0765C112.058 62.0765 115.483 59.7159 120.661 61.2424C120.661 61.2424 122.146 68.0961 126.224 70.3781C128.463 71.6292 133.94 71.5191 138.277 70.1184C143.423 68.4502 145.938 68.4502 146.873 70.3781C147.808 72.3059 146.77 74.3125 142.834 75.2489C138.898 76.1852 135.763 83.0311 128.636 83.1176C121.51 83.2042 117.723 76.0357 119.522 69.7407C117.818 66.5226 115.227 63.8624 112.058 62.0765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.058 62.0765C112.058 62.0765 115.483 59.7159 120.661 61.2424C120.661 61.2424 122.146 68.0961 126.224 70.3781C128.463 71.6292 133.94 71.5191 138.277 70.1184C143.423 68.4502 145.938 68.4502 146.873 70.3781C147.808 72.3059 146.77 74.3125 142.834 75.2489C138.898 76.1852 135.763 83.0311 128.636 83.1176C121.51 83.2042 117.723 76.0357 119.522 69.7407C117.818 66.5226 115.227 63.8624 112.058 62.0765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.909 71.6764C144.909 71.7464 144.889 71.8149 144.85 71.8731C144.811 71.9313 144.756 71.9767 144.691 72.0035C144.626 72.0303 144.555 72.0373 144.487 72.0237C144.418 72.01 144.355 71.9763 144.306 71.9267C144.256 71.8772 144.223 71.8141 144.209 71.7454C144.195 71.6768 144.202 71.6056 144.229 71.5408C144.256 71.4761 144.301 71.4208 144.359 71.3819C144.417 71.343 144.486 71.3223 144.556 71.3223C144.649 71.3223 144.739 71.3596 144.806 71.426C144.872 71.4924 144.909 71.5824 144.909 71.6764Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.978 77.4365C122.759 78.5853 113.377 78.2234 109.606 75.3119C105.834 72.4005 110.171 73.7381 110.171 73.7381C110.171 73.7381 105.575 71.3067 105.064 69.4024C104.554 67.4982 107.327 68.6628 107.327 68.6628C107.327 68.6628 103.713 65.5861 103.241 63.7763C102.77 61.9664 105.41 63.0681 105.41 63.0681C105.41 63.0681 102.118 60.6445 102.786 59.0156C103.454 57.3868 120.81 71.2673 126.176 71.7001C131.543 72.1329 131.252 76.2719 126.978 77.4365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M126.978 77.4365C122.759 78.5853 113.377 78.2234 109.606 75.3119C105.834 72.4005 110.171 73.7381 110.171 73.7381C110.171 73.7381 105.575 71.3067 105.064 69.4024C104.554 67.4982 107.327 68.6628 107.327 68.6628C107.327 68.6628 103.713 65.5861 103.241 63.7763C102.77 61.9664 105.41 63.0681 105.41 63.0681C105.41 63.0681 102.118 60.6445 102.786 59.0156C103.454 57.3868 120.81 71.2673 126.176 71.7001C131.543 72.1329 131.252 76.2719 126.978 77.4365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3215 58.292C99.2905 58.2997 99.2582 58.2997 99.2272 58.292C98.4965 58.0324 97.7501 57.7884 96.9958 57.5602C96.9212 57.5367 96.8588 57.4847 96.8221 57.4155C96.7853 57.3464 96.7772 57.2655 96.7993 57.1904C96.8229 57.1157 96.8748 57.0533 96.9438 57.0165C97.0129 56.9797 97.0936 56.9715 97.1686 56.9937C97.9543 57.2219 98.685 57.4737 99.4236 57.7806C99.4894 57.8031 99.545 57.8485 99.5803 57.9085C99.6155 57.9686 99.6281 58.0393 99.6158 58.1078C99.6034 58.1764 99.5669 58.2382 99.5129 58.2821C99.4589 58.326 99.391 58.3491 99.3215 58.3471V58.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 122.162C51.7548 122.162 51.68 122.132 51.6242 122.077C51.5684 122.023 51.5361 121.949 51.534 121.871C51.534 121.793 51.5644 121.718 51.6187 121.662C51.673 121.606 51.7469 121.574 51.8247 121.572C53.3878 121.55 54.9463 121.397 56.484 121.116C56.5611 121.102 56.6404 121.119 56.7051 121.163C56.7697 121.207 56.8145 121.275 56.8298 121.352C56.8377 121.39 56.8379 121.43 56.8302 121.468C56.8226 121.506 56.8073 121.543 56.7853 121.575C56.7633 121.607 56.735 121.635 56.7022 121.656C56.6693 121.677 56.6325 121.691 56.594 121.698C55.0227 121.986 53.4299 122.141 51.8326 122.162ZM47.1183 121.91C45.5328 121.741 43.9587 121.478 42.404 121.124C42.3271 121.107 42.26 121.06 42.2173 120.993C42.1746 120.927 42.1598 120.847 42.1762 120.769C42.1949 120.694 42.2423 120.628 42.3083 120.587C42.3743 120.546 42.4538 120.532 42.5298 120.549C44.0598 120.894 45.6073 121.157 47.1655 121.336C47.2354 121.347 47.2989 121.383 47.3447 121.437C47.3906 121.492 47.4158 121.56 47.4158 121.631C47.4158 121.702 47.3906 121.771 47.3447 121.825C47.2989 121.879 47.2354 121.915 47.1655 121.926L47.1183 121.91ZM61.0805 120.337C61.024 120.337 60.9686 120.321 60.9211 120.29C60.8737 120.259 60.8362 120.215 60.8133 120.164C60.7964 120.128 60.7869 120.089 60.7853 120.05C60.7837 120.011 60.7901 119.972 60.804 119.935C60.818 119.898 60.8392 119.865 60.8665 119.836C60.8937 119.808 60.9264 119.785 60.9626 119.77C62.3896 119.154 63.7144 118.323 64.8912 117.307C64.9513 117.261 65.0267 117.24 65.1019 117.247C65.1772 117.255 65.2468 117.291 65.2967 117.348C65.3466 117.405 65.373 117.478 65.3707 117.554C65.3683 117.63 65.3374 117.702 65.284 117.756C64.06 118.807 62.6854 119.669 61.2062 120.313C61.1628 120.337 61.1143 120.351 61.0648 120.352L61.0805 120.337ZM37.9098 119.802C37.8788 119.809 37.8464 119.809 37.8155 119.802C36.3226 119.306 34.8219 118.724 33.3683 118.086C33.3039 118.049 33.2555 117.99 33.2325 117.919C33.2096 117.848 33.2137 117.772 33.2441 117.704C33.2745 117.636 33.329 117.582 33.397 117.552C33.465 117.523 33.5416 117.519 33.6119 117.543C35.0419 118.173 36.519 118.747 38.004 119.243C38.0776 119.27 38.1377 119.324 38.1715 119.395C38.2052 119.465 38.21 119.546 38.1848 119.621C38.1625 119.675 38.1244 119.721 38.0753 119.754C38.0262 119.786 37.9685 119.803 37.9098 119.802ZM29.2669 115.977C29.2208 115.991 29.1716 115.991 29.1255 115.977C27.719 115.19 26.3519 114.341 25.079 113.451C25.0476 113.429 25.0208 113.401 25.0002 113.368C24.9796 113.336 24.9656 113.3 24.9591 113.262C24.9525 113.224 24.9535 113.185 24.9619 113.147C24.9704 113.109 24.9861 113.074 25.0083 113.042C25.0305 113.011 25.0587 112.984 25.0912 112.963C25.1238 112.943 25.16 112.929 25.198 112.922C25.2359 112.916 25.2748 112.917 25.3123 112.925C25.3499 112.933 25.3854 112.949 25.4169 112.971C26.674 113.845 28.0176 114.687 29.4162 115.466C29.45 115.485 29.4798 115.51 29.5037 115.541C29.5276 115.571 29.5452 115.606 29.5554 115.643C29.5657 115.681 29.5684 115.72 29.5633 115.758C29.5583 115.797 29.5457 115.834 29.5262 115.867C29.493 115.918 29.4453 115.958 29.3894 115.982C29.3334 116.006 29.2716 116.012 29.2119 116.001L29.2669 115.977ZM68.1126 114.175C68.0665 114.189 68.0173 114.189 67.9712 114.175C67.9373 114.157 67.9076 114.131 67.8837 114.101C67.8598 114.07 67.8422 114.035 67.8319 113.998C67.8217 113.961 67.819 113.921 67.824 113.883C67.829 113.845 67.8417 113.808 67.8612 113.774C68.1048 113.349 68.3326 112.909 68.5369 112.452C68.9742 111.489 69.3163 110.484 69.5583 109.454C69.5787 109.378 69.6277 109.312 69.695 109.271C69.7623 109.23 69.8428 109.217 69.9198 109.234C69.9955 109.254 70.0602 109.304 70.0999 109.371C70.1396 109.439 70.1511 109.52 70.1319 109.596C69.8755 110.66 69.5204 111.698 69.0712 112.696C68.859 113.168 68.6233 113.632 68.3719 114.073C68.3384 114.123 68.2904 114.162 68.2343 114.185C68.1782 114.207 68.1166 114.212 68.0576 114.199L68.1126 114.175ZM21.5198 110.54C21.4506 110.539 21.384 110.514 21.3312 110.469C20.1346 109.411 19.0135 108.27 17.9762 107.054C17.9219 106.998 17.8916 106.924 17.8916 106.846C17.8916 106.768 17.9219 106.693 17.9762 106.637C18.0306 106.583 18.104 106.553 18.1805 106.553C18.2569 106.553 18.3303 106.583 18.3848 106.637C19.4033 107.827 20.5034 108.944 21.6769 109.981C21.7311 110.037 21.7615 110.112 21.7615 110.19C21.7615 110.268 21.7311 110.343 21.6769 110.398C21.6574 110.441 21.628 110.478 21.591 110.507C21.5541 110.536 21.5108 110.555 21.4648 110.564L21.5198 110.54ZM70.3755 105.079C70.3366 105.079 70.2982 105.071 70.2624 105.056C70.2266 105.041 70.1942 105.019 70.1671 104.991C70.14 104.963 70.1187 104.93 70.1046 104.894C70.0904 104.858 70.0837 104.819 70.0847 104.78C70.0733 103.215 69.9288 101.654 69.6526 100.114C69.6388 100.037 69.6557 99.9572 69.6998 99.8925C69.7439 99.8277 69.8116 99.7829 69.8883 99.7676C69.9662 99.756 70.0456 99.7749 70.1099 99.8203C70.1743 99.8657 70.2187 99.9342 70.234 100.012C70.5168 101.586 70.664 103.181 70.674 104.78C70.674 104.859 70.6426 104.935 70.5866 104.991C70.5306 105.048 70.4547 105.079 70.3755 105.079ZM68.804 95.7467C68.7404 95.7461 68.6787 95.7251 68.6278 95.6869C68.5769 95.6487 68.5396 95.5952 68.5212 95.5342C68.1205 94.1572 67.6255 92.6936 67.0205 91.0569C67.0054 91.0203 66.998 90.9811 66.9986 90.9415C66.9993 90.902 67.0079 90.863 67.0241 90.8269C67.0403 90.7908 67.0636 90.7584 67.0927 90.7317C67.1218 90.7049 67.156 90.6844 67.1933 90.6713C67.2663 90.6456 67.3465 90.6493 67.4168 90.6816C67.4872 90.7139 67.5423 90.7723 67.5705 90.8444C68.1833 92.4969 68.6783 93.992 69.0869 95.3611C69.1091 95.4362 69.1009 95.5171 69.0642 95.5862C69.0274 95.6554 68.9651 95.7074 68.8905 95.731L68.804 95.7467ZM65.5512 86.8156C65.4967 86.816 65.4432 86.8007 65.3972 86.7713C65.3512 86.742 65.3146 86.7 65.2919 86.6504C64.789 85.3914 64.1055 83.9435 63.3905 82.4091V82.3304C63.37 82.2618 63.3748 82.1882 63.4039 82.1228C63.4331 82.0574 63.4847 82.0047 63.5494 81.9742C63.6141 81.9438 63.6875 81.9375 63.7564 81.9567C63.8253 81.9758 63.885 82.0191 63.9248 82.0786V82.1573C64.6476 83.7311 65.3233 85.1553 65.8262 86.3907C65.8579 86.4649 65.8592 86.5485 65.8298 86.6236C65.8004 86.6987 65.7426 86.7592 65.669 86.792L65.5512 86.8156ZM61.6226 78.16C61.5648 78.1618 61.5077 78.1463 61.4587 78.1155C61.4097 78.0846 61.371 78.0398 61.3476 77.9868C60.6405 76.3423 60.0747 74.8866 59.6269 73.541C59.6016 73.4669 59.6064 73.3858 59.6402 73.3152C59.674 73.2445 59.7341 73.19 59.8076 73.1633C59.8826 73.1384 59.9645 73.1442 60.0352 73.1796C60.1059 73.215 60.1596 73.2771 60.1847 73.3521C60.6247 74.682 61.1826 76.1219 61.8897 77.7508C61.9052 77.7864 61.9133 77.8247 61.9138 77.8635C61.9142 77.9023 61.9069 77.9408 61.8922 77.9767C61.8776 78.0126 61.8559 78.0452 61.8285 78.0727C61.8011 78.1001 61.7685 78.1217 61.7326 78.1364C61.7064 78.1643 61.6741 78.1858 61.6383 78.1993L61.6226 78.16ZM58.7469 69.1423C58.6766 69.1414 58.6089 69.1156 58.5557 69.0695C58.5025 69.0234 58.4673 68.9601 58.4562 68.8905C58.3213 68.0474 58.253 67.1949 58.2519 66.341C58.2454 65.5781 58.3138 64.8165 58.4562 64.067C58.4788 63.9972 58.5263 63.9381 58.5896 63.9011C58.6529 63.8641 58.7276 63.8517 58.7994 63.8663C58.8713 63.8809 58.9353 63.9214 58.9792 63.9802C59.0231 64.039 59.0439 64.1119 59.0376 64.185C58.9016 64.8955 58.8358 65.6176 58.8412 66.341C58.8439 67.1658 58.9095 67.9892 59.0376 68.804C59.0471 68.8807 59.0272 68.9582 58.982 69.021C58.9369 69.0837 58.8697 69.1271 58.794 69.1423H58.7469ZM60.7976 60.2034C60.7293 60.2053 60.6626 60.183 60.609 60.1404C60.5548 60.0846 60.5245 60.0098 60.5245 59.9319C60.5245 59.854 60.5548 59.7792 60.609 59.7234C61.6639 58.4892 62.9472 57.4712 64.3883 56.7254C64.4573 56.6887 64.5378 56.6805 64.6127 56.7026C64.6876 56.7246 64.7509 56.7752 64.789 56.8434C64.8231 56.9138 64.829 56.9945 64.8056 57.069C64.7823 57.1436 64.7314 57.2065 64.6633 57.2447C63.291 57.9555 62.069 58.9254 61.0648 60.1011C61.0388 60.1446 61.0019 60.1805 60.9578 60.2054C60.9137 60.2302 60.8639 60.2431 60.8133 60.2427L60.7976 60.2034ZM92.4776 56.3477H92.4147C90.9062 56.0329 89.3426 55.7654 87.7633 55.5608C87.725 55.556 87.688 55.5436 87.6545 55.5243C87.6211 55.505 87.5918 55.4792 87.5684 55.4484C87.545 55.4176 87.5279 55.3825 87.5182 55.3451C87.5085 55.3076 87.5064 55.2686 87.5119 55.2303C87.5167 55.192 87.5291 55.1549 87.5484 55.1214C87.5677 55.0879 87.5934 55.0585 87.6241 55.0351C87.6549 55.0116 87.6899 54.9946 87.7273 54.9849C87.7647 54.9751 87.8037 54.973 87.8419 54.9785C89.4133 55.1831 90.9847 55.4507 92.5562 55.7654C92.6266 55.7817 92.6888 55.823 92.7312 55.8817C92.7735 55.9404 92.7932 56.0125 92.7864 56.0846C92.7797 56.1567 92.7471 56.2239 92.6946 56.2737C92.6422 56.3236 92.5734 56.3527 92.5012 56.3556L92.4776 56.3477ZM68.9062 55.6788C68.868 55.683 68.8294 55.6795 68.7925 55.6687C68.7557 55.6579 68.7213 55.6399 68.6914 55.6158C68.6615 55.5917 68.6366 55.5619 68.6182 55.5282C68.5998 55.4945 68.5882 55.4574 68.584 55.4192C68.5799 55.3809 68.5833 55.3423 68.5941 55.3054C68.6049 55.2685 68.6229 55.234 68.647 55.2041C68.671 55.1741 68.7008 55.1492 68.7345 55.1308C68.7682 55.1123 68.8051 55.1007 68.8433 55.0966C70.395 54.7479 71.971 54.5191 73.5576 54.412C73.6355 54.4076 73.7121 54.434 73.7708 54.4855C73.8296 54.537 73.8659 54.6094 73.8719 54.6874C73.8751 54.7263 73.8705 54.7654 73.8583 54.8024C73.8461 54.8395 73.8266 54.8737 73.801 54.9031C73.7753 54.9324 73.744 54.9563 73.709 54.9734C73.6739 54.9904 73.6358 55.0002 73.5969 55.0021C72.0365 55.1032 70.4865 55.3268 68.9612 55.671L68.9062 55.6788ZM83.049 55.128C81.6819 55.0336 80.0555 54.9313 78.3347 54.8998C78.2569 54.8978 78.183 54.8654 78.1287 54.8095C78.0744 54.7537 78.044 54.6788 78.044 54.6008C78.044 54.5619 78.0518 54.5234 78.0669 54.4876C78.082 54.4517 78.1041 54.4193 78.1319 54.3921C78.1598 54.365 78.1928 54.3437 78.2289 54.3295C78.2651 54.3154 78.3038 54.3086 78.3426 54.3097C80.079 54.349 81.7212 54.4434 83.0569 54.5379C83.0958 54.5398 83.1339 54.5496 83.169 54.5667C83.204 54.5837 83.2353 54.6076 83.2609 54.6369C83.2866 54.6663 83.3061 54.7005 83.3183 54.7376C83.3305 54.7746 83.3351 54.8137 83.3319 54.8526C83.3376 54.9237 83.3178 54.9944 83.276 55.0521C83.2342 55.1099 83.1732 55.1507 83.104 55.1674L83.049 55.128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4075 103.277C15.3548 103.278 15.3028 103.265 15.2572 103.238C15.2115 103.212 15.1738 103.174 15.1482 103.128C14.7509 102.437 14.3966 101.722 14.0875 100.987C14.0721 100.952 14.0639 100.913 14.0635 100.875C14.0631 100.836 14.0704 100.797 14.085 100.761C14.0997 100.725 14.1213 100.693 14.1487 100.665C14.1762 100.638 14.2088 100.616 14.2446 100.602C14.3167 100.573 14.3971 100.573 14.469 100.602C14.5409 100.632 14.5985 100.688 14.6296 100.759C14.9331 101.471 15.2767 102.164 15.6589 102.836C15.6883 102.88 15.7048 102.931 15.7067 102.984C15.7086 103.037 15.6958 103.089 15.6697 103.135C15.6435 103.181 15.6051 103.218 15.5588 103.243C15.5125 103.269 15.4601 103.28 15.4075 103.277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.833 165.473H81.0068V171.595H110.833V165.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.833 165.473H81.0068V171.595H110.833V165.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.5704 165.473H81.0068V171.595H93.5704V165.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0068 166.354H107.556L81.0068 167.109V166.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.833 167.416L87.8193 167.99H110.833V167.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M82.2256 169.131L93.5713 168.667L110.252 169.131L93.5713 169.391L82.2256 169.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0068 170.43H100.665L81.0068 170.894V170.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.787 170.894L97.6572 171.137H110.834L110.787 170.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.685 159.351H76.8594V165.472H106.685V159.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.685 159.351H76.8594V165.472H106.685V159.351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.4229 159.351H76.8594V165.472H89.4229V159.351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.8594 160.232H103.409L76.8594 160.98V160.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.684 161.294L83.6709 161.868H106.684V161.294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.0693 163.009L89.4151 162.537L106.096 163.009L89.4151 163.269L78.0693 163.009Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.8594 164.301H96.5179L76.8594 164.773V164.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.637 164.772L93.5078 165.016H106.684L106.637 164.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.087 153.221H80.2617V159.343H110.087V153.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.087 153.221H80.2617V159.343H110.087V153.221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.8253 153.221H80.2617V159.343H92.8253V153.221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.2607 154.102H106.81L80.2607 154.857V154.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.087 155.164L87.0732 155.738H110.087V155.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.4795 156.88L92.8252 156.416L109.506 156.88L92.8252 157.14L81.4795 156.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.2617 158.179H99.9203L80.2617 158.643V158.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.047 158.643L96.918 158.887H110.087L110.047 158.643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.957 171.468L130.727 168.533H162.596L177.265 170.005L177.823 171.468H129.957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.596 168.533V171.468H129.957L130.727 168.533H162.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.193 154.488C156.236 154.843 156.202 155.204 156.094 155.546C155.985 155.888 155.805 156.202 155.566 156.468C155.326 156.734 155.032 156.946 154.704 157.089C154.376 157.232 154.021 157.303 153.663 157.297H104.855C104.091 157.28 103.36 156.986 102.798 156.469C102.235 155.952 101.88 155.248 101.798 154.488L98.8988 123.193C98.8674 122.888 98.8887 122.579 98.9617 122.281C99.0971 121.731 99.415 121.244 99.8634 120.899C100.312 120.555 100.864 120.373 101.429 120.384H150.269C151.032 120.401 151.763 120.695 152.326 121.212C152.888 121.729 153.243 122.433 153.325 123.193L156.193 154.488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.49 157.296H104.855C104.091 157.28 103.36 156.985 102.798 156.469C102.235 155.952 101.88 155.247 101.798 154.487L98.8988 123.193C98.8674 122.887 98.8887 122.579 98.9617 122.28H147.597C148.361 122.297 149.092 122.591 149.654 123.108C150.217 123.625 150.572 124.329 150.654 125.089L153.553 156.384C153.584 156.689 153.563 156.998 153.49 157.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.956 138.104H130.052L127.365 167.054L143.331 169.454V171.468H109.702V169.454L116.593 167.054L119.956 138.104Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.052 138.104L122.572 171.012L116.593 170.831L119.956 138.104H130.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.004 297.691H125.196L116.545 177.102H122.933L130.004 297.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.012 297.691H125.196L116.969 183.098L116.545 177.299H122.933L123.278 183.098L130.012 297.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.278 182.807H116.969L116.545 177.299H122.933L123.278 182.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.331 297.691H160.522L159.736 177.102H166.116L165.331 297.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.123 177.3L165.997 196.759L165.337 297.692H160.521L159.861 196.759L159.735 177.3H166.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.123 177.3L165.997 196.972H159.861L159.735 177.3H166.123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.433 297.691H211.624L202.974 177.102H209.361L216.433 297.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M216.441 297.691H211.624L203.398 183.098L202.974 177.299H209.361L209.707 183.098L216.441 297.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M209.707 182.807H203.398L202.974 177.299H209.361L209.707 182.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9414 297.691H70.1328L77.2042 177.102H83.5921L74.9414 297.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M83.5921 177.299L83.1678 183.098L74.9414 297.691H70.1328L76.8585 183.098L77.2042 177.299H83.5921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.2051 177.299H83.5929L83.1687 182.807H76.8594L77.2051 177.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1436 174.097H214.421V178.432C214.421 178.656 214.377 178.877 214.291 179.083C214.206 179.289 214.081 179.476 213.924 179.634C213.766 179.792 213.579 179.917 213.373 180.003C213.167 180.088 212.946 180.132 212.724 180.132H73.8407C73.3906 180.132 72.9589 179.953 72.6406 179.634C72.3224 179.315 72.1436 178.883 72.1436 178.432V174.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.1436 174.097H214.421V178.432C214.421 178.656 214.377 178.877 214.291 179.083C214.206 179.289 214.081 179.476 213.924 179.634C213.766 179.792 213.579 179.917 213.373 180.003C213.167 180.088 212.946 180.132 212.724 180.132H73.8407C73.3906 180.132 72.9589 179.953 72.6406 179.634C72.3224 179.315 72.1436 178.883 72.1436 178.432V174.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M214.421 174.089H72.1436V177.11H214.421V174.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.408 174.884H69.1591C68.7089 174.884 68.2773 174.705 67.959 174.386C67.6407 174.067 67.4619 173.635 67.4619 173.184C67.4619 172.733 67.6405 172.299 67.9585 171.979C68.2766 171.659 68.7082 171.479 69.1591 171.477H217.408C217.858 171.479 218.29 171.659 218.608 171.979C218.926 172.299 219.105 172.733 219.105 173.184C219.105 173.635 218.926 174.067 218.608 174.386C218.289 174.705 217.858 174.884 217.408 174.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M217.408 174.884H69.1591C68.7089 174.884 68.2773 174.705 67.959 174.386C67.6407 174.067 67.4619 173.635 67.4619 173.184C67.4619 172.733 67.6405 172.299 67.9585 171.979C68.2766 171.659 68.7082 171.479 69.1591 171.477H217.408C217.858 171.479 218.29 171.659 218.608 171.979C218.926 172.299 219.105 172.733 219.105 173.184C219.105 173.635 218.926 174.067 218.608 174.386C218.289 174.705 217.858 174.884 217.408 174.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.333 166.228L184.156 163.49C184.336 163.221 184.579 163 184.864 162.848C185.149 162.696 185.467 162.616 185.79 162.616H188.1C188.292 162.617 188.483 162.646 188.666 162.703L196.908 165.205C197.376 165.345 197.775 165.657 198.024 166.078L199.21 168.069L182.333 166.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M199.211 168.069L187.198 166.763L182.318 166.228L184.141 163.49C184.321 163.221 184.564 163 184.849 162.848C185.134 162.696 185.452 162.616 185.775 162.616H188.085C188.28 162.617 188.473 162.647 188.659 162.703L188.84 162.758L196.893 165.205C197.364 165.344 197.766 165.656 198.017 166.078L199.211 168.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M199.211 168.068L187.197 166.762L188.839 162.757L196.893 165.204C197.364 165.343 197.765 165.655 198.017 166.077L199.211 168.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.914 171.208V171.468H179.441L180.384 167.778C180.559 167.1 180.954 166.5 181.508 166.072C182.062 165.645 182.742 165.414 183.441 165.417H194.739C195.115 165.415 195.488 165.482 195.839 165.614L197.254 166.141L202.864 168.234C203.469 168.459 203.991 168.865 204.358 169.397C204.725 169.929 204.919 170.562 204.914 171.208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.915 171.209V171.468H194.457L195.015 167.479C195.051 167.231 195.142 166.995 195.28 166.788C195.419 166.58 195.603 166.406 195.817 166.278C196.032 166.151 196.273 166.073 196.521 166.051C196.77 166.028 197.02 166.062 197.254 166.149L202.864 168.242C203.468 168.466 203.989 168.871 204.356 169.402C204.723 169.932 204.918 170.563 204.915 171.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.084 168.761L199.415 158.759C199.448 158.658 199.502 158.564 199.575 158.485C199.647 158.407 199.736 158.345 199.835 158.304C199.934 158.264 200.04 158.246 200.147 158.251C200.254 158.256 200.358 158.285 200.453 158.335C200.597 158.418 200.712 158.545 200.78 158.698C200.848 158.851 200.865 159.021 200.83 159.184L198.025 169.854C198.025 169.854 196.163 170.61 196.084 168.761Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.334 170.641H180.856L181.139 169.186H182.616L182.334 170.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.534 170.588H183.057L183.339 169.132H184.817L184.534 170.588Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2791_1173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 318.686,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsImage);
export default __webpack_public_path__ + "static/media/contactUsImage.4bf0f75669cd9eb293f10d21fc4c96f9.svg";
export { ForwardRef as ReactComponent };